export const post_search = (data) => {
    return {
        type: 'POST_SEARCH',
        data,
    }
}
